// Shared open-modal counter. Pauses expensive backdrop-blur-over-animation
// compositing (see theme.css html[data-flix-modal-open]) while any modal is up,
// without one modal's close() prematurely re-enabling animations the other
// modal still needs paused.
(function () {
  let count = 0;
  window.flixModalOpen = function () {
    count += 1;
    document.documentElement.setAttribute('data-flix-modal-open', '');
  };
  window.flixModalClose = function () {
    count = Math.max(0, count - 1);
    if (count === 0) document.documentElement.removeAttribute('data-flix-modal-open');
  };
})();
